// 导入axios实例
import httpRequest from '@/utils/request.js'
import { getToken } from '@/utils/cache'
export function apiRealName(data) { return httpRequest({ url: 'vexe/v1/user/realName', method: 'post', data, notifyFailure: true }) }
export function apiUpdateSafePwd(data) { return httpRequest({ url: 'vexe/v1/user/updateSafePwd', method: 'post', data, notifyFailure: true }) }
export function apiSafePasswordCode(data) { return httpRequest({ url: 'vexe/v1/sms/code', method: 'post', data, notifyFailure: true }) }
export function apiUserLevels(param) { return httpRequest({ url: 'vexe/v1/user/levels', method: 'get', params: param }) }
export function apiSignInfo() { return httpRequest({ url: 'vexe/v1/sign/index', method: 'get' }) }
export function apiSignIn() { return httpRequest({ url: 'vexe/v1/sign/signIn', method: 'post', data: {} }) }
export function apiTaskList(params) { return httpRequest({ url: 'vexe/v1/task/list', method: 'get', params }) }
export function apiTaskReceive(data) { return httpRequest({ url: 'vexe/v1/task/receive', method: 'post', data }) }
export function apiTurntableInfo() { return httpRequest({ url: 'vexe/v1/turntable/info', method: 'get' }) }
export function apiTurntableStart() { return httpRequest({ url: 'vexe/v1/turntable/startTurntable', method: 'post', data: {}, notifyFailure: true }) }
export function apiTurntableRecords(params) { return httpRequest({ url: 'vexe/v1/turntable/winRecord', method: 'get', params }) }
export function apiTurntableAwards() { return httpRequest({ url: 'vexe/v1/turntable/awardList', method: 'get' }) }
export function apiActivityList() { return httpRequest({ url: 'vexe/v1/activity/list', method: 'get' }) }
export function apiActivityDetail(params) { return httpRequest({ url: 'vexe/v1/activity/detail', method: 'get', params }) }
export function apiBalanceBaby(param) { return httpRequest({ url: 'vexe/v1/user/balanceBaby', method: 'get', params: param }) }
export function apiBalanceBabyRecords(param) { return httpRequest({ url: 'vexe/v1/user/balanceBabyRecords', method: 'get', params: param }) }
export function apiBalanceBabyDetail(param) { return httpRequest({ url: 'vexe/v1/user/recordBalanceBabyDetail', method: 'get', params: param }) }
export function apiTransferInBaby(param) { return httpRequest({ url: 'vexe/v1/user/transferInBalanceBaby', method: 'post', data: param }) }
export function apiTransferOutBaby(param) { return httpRequest({ url: 'vexe/v1/user/transferOutBalanceBaby', method: 'post', data: param }) }
export function apiRechargeRecord(param) { return httpRequest({ url: 'vexe/v1/user/rechargeRecord', method: 'get', params: param }) }
export function apiWithdrawRecord(param) { return httpRequest({ url: 'vexe/v1/user/withdrawRecord', method: 'post', data: param }) }
export function apiRechargeRecordInfo(param) { return httpRequest({ url: 'vexe/v1/user/rechargeRecordInfo', method: 'get', params: param }) }
export function apiWithdrawRecordInfo(param) { return httpRequest({ url: 'vexe/v1/user/withdrawRecordInfo', method: 'get', params: param }) }
export function apiCouponList(param) { return httpRequest({ url: 'vexe/v1/coupon/listNew', method: 'get', params: param }) }
export function apiCouponDetail(param) { return httpRequest({ url: 'vexe/v1/coupon/detail', method: 'get', params: param }) }
export function apiOffline(param) { return httpRequest({ url: 'vexe/v1/rebate/offline', method: 'get', params: param }) }
export function apiOfflineConsult(param) { return httpRequest({ url: 'vexe/v1/rebate/offlineConsult', method: 'get', params: param }) }
export function apiRebateDetail(param) { return httpRequest({ url: 'vexe/v1/rebate/rebateDetail', method: 'get', params: param }) }
export function apiOfflineUserInfo(param) { return httpRequest({ url: 'vexe/v1/rebate/offlineUserInfo', method: 'get', params: param }) }
export function apiOfflineConsultInfo(param) { return httpRequest({ url: 'vexe/v1/rebate/offlineConsultInfo', method: 'get', params: param }) }
export function apiRebateDetailInfo(param) { return httpRequest({ url: 'vexe/v1/rebate/rebateDetailInfo', method: 'get', params: param }) }
export function apiChatAgent(param) { return httpRequest({ url: 'vexe/v1/chat/agent', method: 'get', params: param, rawResponse: true }) }
export function apiChatRecords(param) { return httpRequest({ url: 'vexe/v1/chat/records', method: 'get', params: param, rawResponse: true }) }
export function apiChatUpload(param) { return httpRequest({ url: 'vexe/v1.user/upload', method: 'post', data: param }) }
export function apiSearchStock(param) { return httpRequest({ url: 'vexe/v1/stock/searchStock', method: 'get', params: param }) }
export function apiEntrust(param) { return httpRequest({ url: 'vexe/v1/consult/entrust', method: 'get', params: param }) }
export function apiCancelOrder(param) { return httpRequest({ url: 'vexe/v1/consult/canceled', method: 'post', data: param }) }
export function apiCancelOrders(param) { return httpRequest({ url: 'vexe/v1/consult/canceledAll', method: 'post', data: param }) }
export function apiOrderInfo(param) { return httpRequest({ url: 'vexe/v1/consult/orderInfo', method: 'get', params: param }) }
export function apiRecords(param) { return httpRequest({ url: 'vexe/v1/user/records', method: 'get', params: param }) }
export function apiRecordType(param) { return httpRequest({ url: 'vexe/v1/user/recordType', method: 'get', params: param }) }
export function apiRecordDetail(param) { return httpRequest({ url: 'vexe/v1/user/recordDetail', method: 'get', params: param }) }
export function apiWithdrawInfo(param) { return httpRequest({ url: 'vexe/v1/user/withdrawInfo', method: 'get', params: param }) }
export function apiWithdraw(param) { return httpRequest({ url: 'vexe/v1/user/withdraw', method: 'post', data: param }) }
export function apiRechargeInfo(param) { return httpRequest({ url: 'vexe/v1/user/rechargeInfo', method: 'get', params: param }) }
export function apiRecharge(param) { return httpRequest({ url: 'vexe/v1/user/recharge', method: 'post', data: param }) }
export function apiRechargeStatus(param) { return httpRequest({ url: 'vexe/v1/user/rechargeStatus', method: 'get', params: param }) }
export function apiRechargeSuInfo(param) { return httpRequest({ url: 'vexe/v1/user/rechargeSuInfo', method: 'get', params: param }) }
export function apiThirdPayUserinfo(param) { return httpRequest({ url: 'vexe/v1/user/thirdPayUserinfo', method: 'post', data: param }) }
export function apiCheckSafePwd(param) { return httpRequest({ url: 'vexe/v1/user/checkSafePwd', method: 'post', data: param }) }
export function apiSuPayCheck(param) { return httpRequest({ url: 'vexe/v1/user/suPayCheck', method: 'post', data: param }) }
export function apiSuPayAdd(param) { return httpRequest({ url: 'vexe/v1/user/suPayAdd', method: 'post', data: param }) }
export function apiMobileCode(param) {
    return httpRequest({ url: 'vexe/v1/sms/getCode', method: 'post', data: param })
}
export function apiVerifyPhone(param) {
    return httpRequest({ url: 'vexe/v1/user/phone', method: 'post', data: param })
}
export function apiSetLoginPassword(param) {
    return httpRequest({ url: 'vexe/v1/user/password', method: 'post', data: param })
}
export function apiSetPayPassword(param) {
    return httpRequest({ url: 'vexe/v1/user/pay_password', method: 'post', data: param })
}
export function apiBindPhone(param) {
    return httpRequest({ url: 'vexe/v1/user/newPhone', method: 'post', data: param })
}
export function apiRandomKey(param) {
    return httpRequest({ url: 'vexe/v1/index/randomKey', method: 'get', params: param })
}
export function apiCards(param) {
    return httpRequest({ url: 'vexe/v1/user/cards', method: 'get', params: param })
}
export function apiAddCard(param) {
    return httpRequest({ url: 'vexe/v1/user/addCard', method: 'post', data: param })
}
export function apiDealCard(param) {
    return httpRequest({ url: 'vexe/v1/user/dealCard', method: 'post', data: param })
}
export function apiStockUp(param) {
    return httpRequest({
        url: 'vexe/v1/stock/up',
        method: 'get',
        params: param,
    })
}
export function apiStockDown(param) {
    return httpRequest({
        url: 'vexe/v1/stock/down',
        method: 'get',
        params: param,
    })
}
export function apiStockCje(param) {
    return httpRequest({
        url: 'vexe/v1/stock/cje',
        method: 'get',
        params: param,
    })
}
export function apiStockHsl(param) {
    return httpRequest({
        url: 'vexe/v1/stock/hsl',
        method: 'get',
        params: param,
    })
}
export function apiStockRiseRank(param) {
    return httpRequest({
        url: 'vexe/v1/stock/stockRiseRank',
        method: 'get',
        params: param,
    })
}
export function apiLogin(param) {
    return httpRequest({
        url: 'vexe/v1/login/index', authChallenge: true,
        method: 'post',
        data: param,
    })
}
export function apiSmsLogin(param) {
    return httpRequest({
        url: 'vexe/v1/login/smsLogin', authChallenge: true,
        method: 'post',
        data: param,
    })
}
export function apiCode(param) {
    return httpRequest({
        url: 'vexe/v1/sms/code',
        method: 'post',
        data: param,
    })
}
export function apiRegister(param) {
    return httpRequest({
        url: 'vexe/v1/register',
        method: 'post',
        data: param,
    })
}
export function apiForget(param) {
    return httpRequest({
        url: 'vexe/v1/login/forget',
        method: 'post',
        data: param,
    })
}
export function apiLogout(param) {
    return httpRequest({
        url: '/vexe/v1/user/logout',
        method: 'post',
        data: param,
    })
}
export function apiStockCateList(param) {
    return httpRequest({
        url: 'vexe/v1/stock/stockCateList',
        method: 'get',
        params: param,
    })
}
export function apiStockListByCate(param) {
    return httpRequest({
        url: 'vexe/v1/stock/stockListByCate',
        method: 'get',
        params: param,
    })
}
export function apiSystem(param) {
    return httpRequest({
        url: 'vexe/v1/notices/system',
        method: 'get',
        params: param,
    })
}
export function apiNotice(param) {
    return httpRequest({
        url: 'vexe/v1/notices/notice',
        method: 'get',
        params: param,
    })
}
export function apiGonggao(param) {
    return httpRequest({
        url: 'vexe/v1/notices/gonggao',
        method: 'get',
        params: param,
    })
}
export function apiConfig(param) {
    return httpRequest({
        url: 'vexe/v1/sys_config/list',
        publicRequest: true,
        method: 'post',
        data: param,
    })
}
export function apiHomePopups(multiple) {
    return httpRequest({
        url: multiple ? 'vexe/v1/index/popupList' : 'vexe/v1/index/popup',
        method: 'get', silent: true,
    })
}
export function apiBaseData(param) {
    return httpRequest({
        url: 'vexe/v1/stock/baseData',
        method: 'get',
        params: param,
    })
}
export function apiMingXi(param) {
    return httpRequest({
        url: 'vexe/v1/stock/mingXi',
        method: 'get',
        params: param,
    })
}
export function apiBuySell(param) {
    return httpRequest({
        url: 'vexe/v1/stock/buySell',
        method: 'get',
        params: param,
    })
}

export function apiTuijian(param) {
    return httpRequest({
        url: 'vexe/v1/news/tuijian',
        method: 'get',
        params: param,
    })
}
export function apiKuaixun(param) {
    return httpRequest({
        url: 'vexe/v1/news/kuaixun',
        method: 'get',
        params: param,
    })
}
export function apiRewen(param) {
    return httpRequest({
        url: 'vexe/v1/news/rewen',
        method: 'get',
        params: param,
    })
}
export function apiNewsDetail(param) {
    return httpRequest({ url: 'vexe/v1/news/detail', method: 'get', params: param })
}
export function apiApplyInfo(param) {
    return httpRequest({
        url: 'vexe/v1/consult/applyInfo',
        method: 'get',
        params: param,
    })
}
export function apiBase(param) {
    return httpRequest({
        url: 'vexe/v1/index/base',
        method: 'get',
        params: param,
    })
}
//
export function apiAddedInfo(param) {
    return httpRequest({
        url: 'vexe/v1/consult/addedInfo',
        method: 'get',
        params: param,
    })
}
export function apiAdded(param) {
    return httpRequest({
        url: 'vexe/v1/consult/added',
        method: 'post',
        data: param,
    })
}
export function apiConsultList(param) {
    return httpRequest({
        url: 'vexe/v1/consult/list',
        method: 'get',
        params: param,
    })
}
export function apiGetRealName(param) {
    return httpRequest({
        url: 'vexe/v1/user/getRealName',
        method: 'get',
        params: param,
    })
}
export function apiUserInfo(param) {
    if (!getToken()) return Promise.resolve(0)
    return httpRequest({
        url: 'vexe/v1/user/userInfo',
        method: 'get',
        params: param,
    })
}
export function stockRank() {
    return httpRequest({
        url: 'vexe/v1/stock/stockRank',
        method: 'get',
    })
}
export function marketIndex() {
    return httpRequest({
        url: 'vexe/v1/stock/marketIndex',
        method: 'get',
    })
}
export function boardAll(param){
    return httpRequest({
        url: 'vexe/v1/stock/boardAll',
        method: 'get',
        params: param
    })
}
export function floatList(param){
    return httpRequest({
        url: 'vexe/v1/consult/float_list',
        method: 'get',
        params: param
    })
}
export function getPosition(param){
    return httpRequest({
        url: 'vexe/v1/consult/position',
        method: 'get',
        params: param
    })
}
export function guPiaoBuyApi(param){
    return httpRequest({
        url: 'vexe/v1/consult/buy',
        successMessage: '买入委托已提交',
        method: 'post',
        params: param
    })
}
export function guPiaoSellApi(param){
    return httpRequest({
        url: 'vexe/v1/consult/sell',
        successMessage: '卖出委托已提交',
        method: 'post',
        params: param
    })
}
export function getApplyInfoApi(param){
    return httpRequest({
        url: 'vexe/v1/contract/applyInfo',
        method: 'get',
        params: param
    })
}
export function indexExchangeRateInfo(param){
    return httpRequest({
        url: 'vexe/v1/stockIndex/indexExchangeRateInfo',
        method: 'get',
        params: param
    })
}
export function addedInfoApi(param){
    return httpRequest({
        url: 'vexe/v1/consult/addedInfo',
        method: 'get',
        params: param
    })
}
export function createInfoApi(param){
    return httpRequest({
        url: 'vexe/v1/contract/createInfo',
        method: 'post',
        params: param
    })
}
export function addedApi(param){
    return httpRequest({
        url: 'vexe/v1/consult/added',
        method: 'post',
        params: param
    })
}
export function gMcreatedApi(param){
    return httpRequest({
        url: 'vexe/v1/contract/created',
        method: 'post',
        params: param
    })
}
const pendingWatchlists = new Map()
export function optionalNewApi(param = {}){
    const key = JSON.stringify([getToken(), Object.keys(param).sort().map(name => [name, param[name]])])
    if (pendingWatchlists.has(key)) return pendingWatchlists.get(key)
    const pending = httpRequest({
        url: 'vexe/v1/user/optionalNew',
        method: 'get',
        params: param
    }).finally(() => pendingWatchlists.delete(key))
    pendingWatchlists.set(key, pending)
    return pending
}
export function boardApi(param){
    return httpRequest({
        url: 'vexe/v1/stock/board',
        method: 'get',
        params: param
    })
}
export function agentInfoApi(param){
    return httpRequest({
        url: 'vexe/v1/rebate/agentInfo',
        method: 'get',
        params: param
    })
}

export function apiMarketInfo() { return httpRequest({ url: 'vexe/v1/stock/market', method: 'get' }) }
export function apiFreeTrialInfo() { return httpRequest({ url: 'vexe/v1/user/freeTrialInfo', method: 'get' }) }
export function apiFreeTrialClaim() { return httpRequest({ url: 'vexe/v1/user/freeTrial', method: 'post', notifyFailure: true }) }

// 股指竞猜（PC vexe 模块）
export function apiIndexPredictionMarketList() { return httpRequest({ url: 'vexe/v1/indexPrediction/marketList', method: 'get' }) }
export function apiIndexPredictionDetail(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/detail', method: 'get', params: param }) }
export function apiIndexPredictionMinuteKline(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/minuteKline', method: 'get', params: param, silent: true }) }
export function apiIndexPredictionRules() { return httpRequest({ url: 'vexe/v1/indexPrediction/rules', method: 'get' }) }
export function apiIndexPredictionRecords(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/recordList', method: 'get', params: param }) }
export function apiIndexPredictionOrders(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/orderList', method: 'get', params: param }) }
export function apiIndexPredictionExchangeInfo() { return httpRequest({ url: 'vexe/v1/indexPrediction/exchangeInfo', method: 'get' }) }
export function apiIndexPredictionBet(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/bet', method: 'post', data: param, notifyFailure: true }) }
export function apiIndexPredictionExchangeIn(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/exchangeIn', method: 'post', data: param }) }
export function apiIndexPredictionExchangeOut(param) { return httpRequest({ url: 'vexe/v1/indexPrediction/exchangeOut', method: 'post', data: param }) }
